import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
  history: createWebHistory('/v2/'),
  routes: [
    {
      path: '/',
      redirect: '/call-center',
    },
    {
      path: '/call-center',
      name: 'call-center',
      component: () => import('@/views/CallCenter.vue'),
    },
    {
      path: '/voicemail',
      redirect: '/voicemail/new',
    },
    {
      path: '/voicemail/:folder',
      name: 'voicemail',
      component: () => import('@/views/VoicemailView.vue'),
      props: true,
    },
    {
      path: '/greetings',
      name: 'greetings',
      component: () => import('@/views/GreetingsView.vue'),
    },
    {
      path: '/answer-rules',
      name: 'answer-rules',
      component: () => import('@/views/AnswerRulesView.vue'),
    },
    {
      path: '/reports',
      name: 'reports',
      component: () => import('@/views/ReportsView.vue'),
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/views/SettingsView.vue'),
      meta: { hideNav: true },
    },
  ],
});

export default router;
